export default __webpack_public_path__ + "static/media/girls-diagram.a76582fd.svg";